import { Button, Group, LoadingOverlay, Stack } from "@mantine/core";
import { useRef, useState } from "react";
import TextEditor from "../../../../../../../components/ExternalEditors/TextEditor";
import { useLanguage } from "../../../../../../../stores/LanguageStore";
import {
  editNote,
  uploadNoteAttachments,
} from "../../../../../../../api/PRMAPI";
import {
  useLeadsContainerStore,
  useLeadsSheetStore,
} from "../../../../../../../stores/LeadsStore";
import { notifications } from "@mantine/notifications";
import BackButton from "../../../../../../../components/View/BackButton";
import { IconEdit } from "@tabler/icons-react";
import { useProfileStore } from "../../../../../../../stores/UserStore";
import NoteAttachments from "./NoteAttachments";
import AddNoteAttachments from "./AddNoteAttachments";

const EditNoteContent = ({
  setIsEdit,
  item,
  outsideCurrent,
  container,
  small,
}) => {
  const editorRef = useRef();
  const lang = useLanguage((s) => s.language);
  const profile = useProfileStore((s) => s.profile);
  const current = useLeadsSheetStore((s) => s.current);
  const setCurrent = useLeadsSheetStore((s) => s.setCurrent);
  const updateContainerItem = useLeadsContainerStore(
    (s) => s.updateContainerItem
  );
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState(
    item?.attachments?.map((x) => ({
      ...x,
      name: x?.filename,
      size: x?.file_size,
    }))
  );

  const handleSave = () => {
    setLoading(true);
    const html = editorRef.current.getContent();
    editNote({
      prospect_id: outsideCurrent?.id || current?.id,
      note_id: item.id,
      note: html,
    })
      .then(async (response) => {
        let attachments = null;
        let newFiles = files.filter((x) => !x.id);

        if (newFiles.length > 0) {
          try {
            let formData = new FormData();

            newFiles.forEach((file) => {
              formData.append("attachments[]", file);
            });

            attachments = await uploadNoteAttachments({
              note_id: item.id,
              prospect_id: current.id,
              formData,
            });
          } catch (error) {
            console.error("Attachment upload failed:", error);
          }
        }

        let newNote = {
          ...item,
          date: item.date,
          id: item.id,
          date_updated: new Date().toISOString(),
          updated_by: profile.id,
          note: html,
          history_type: "note",
          attachments: [
            ...files,
            ...(attachments?.data?.attachment_ids?.length ? newFiles : []),
          ],
        };
        let newHistory = current?.history?.map((x) => {
          if (x.id === item.id) {
            return newNote;
          }
          return x;
        });
        if (outsideCurrent) {
          updateContainerItem(container.id, current.id, {
            ...current,
            history: newHistory,
          });
        } else {
          setCurrent({
            ...current,
            history: newHistory,
          });
        }

        notifications.show({
          message: lang.prm.details.notes.edited,
          color: "tertiary.8",
        });
        setIsEdit(false);
      })
      .finally(() => setLoading(false));
  };

  const handleClose = () => {
    setIsEdit(false);

    let newNote = {
      ...item,
      attachments: files?.map((x) => ({
        ...x,
        filename: x.name,
        file_size: x.size,
        file: x,
      })),
    };
    let newHistory = current?.history?.map((x) => {
      if (x.id === item.id) {
        return newNote;
      }
      return x;
    });
    if (outsideCurrent) {
      updateContainerItem(container.id, current.id, {
        ...current,
        history: newHistory,
      });
    } else {
      setCurrent({
        ...current,
        history: newHistory,
      });
    }
  };

  return (
    <Stack w={"100%"} p={4} gap={8}>
      <LoadingOverlay visible={loading} />
      <TextEditor
        editorRef={editorRef}
        id={"tab-note"}
        onInit={(editor) => editor.setContent(item?.note)}
        placeholder={lang.prm.details.notes.placeholder}
        isText
        height={small ? 150 : 280}
        autoSize
        noTop
        toolbar="bold italic underline numlist bullist link |"
        autoFocus
      />

      <NoteAttachments
        files={files}
        setFiles={setFiles}
        item={item}
        current={current}
        isEdit
      />
      <Group justify="end">
        <AddNoteAttachments files={files} setFiles={setFiles} />
        <BackButton onClick={handleClose} ml="auto" />
        <Button
          loading={loading}
          onClick={handleSave}
          leftSection={<IconEdit size={18} />}
          // size="compact-md"
        >
          {lang.global.edit}
        </Button>
      </Group>
    </Stack>
  );
};

export default EditNoteContent;
